document.addEventListener("DOMContentLoaded", function () {
  const h2 = document.querySelector(
    "#shopify-section-template--26588940828856__collection_grid_page_XGMrrV > div > div > h2"
  );

  if (h2) {
    const h1 = document.createElement("h1");

    // h2 ka text copy karo
    h1.innerHTML = h2.innerHTML;

    // h2 ke saare attributes copy karo (class, id, etc.)
    [...h2.attributes].forEach(attr => {
      h1.setAttribute(attr.name, attr.value);
    });

    // h2 ko h1 se replace karo
    h2.parentNode.replaceChild(h1, h2);
  }
});